/** Показывать счётчик в чипе фильтра, если выбрано больше N значений. */
export const MAX_TYPES_IN_BUTTON = 2;
